const ROOT = 'UNIT_PAYMENT_DETAILS_TABS_BANK_ACCOUNTS_';

const actions = {
  LOAD_BANK_ACCOUNTS_REQUEST: `${ROOT}LOAD_BANK_ACCOUNTS_REQUEST`,
  LOAD_BANK_ACCOUNTS_SUCCESS: `${ROOT}LOAD_BANK_ACCOUNTS_SUCCESS`,
  LOAD_BANK_ACCOUNTS_ERROR: `${ROOT}LOAD_BANK_ACCOUNTS_ERROR`,
} as const;

export default actions;
